import { twMerge } from "tailwind-merge";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

interface ProgramAccordionProps {
    list: {
        title: string | React.ReactNode;
        background: string;
        img: string;
        contents?: React.ReactNode;
        pattern?: string;
        patternStyle?: React.CSSProperties;
    }[];
    className?: string;
    triggerClassName?: string;
    contentClassName?: string;
    defaultOpenItems?: number[];
    pattern?: string;
    deco?: string;
    disableToggle?: boolean;
}

export default function ProgramAccordion({
    list,
    className,
    triggerClassName,
    contentClassName,
    defaultOpenItems = [],
    pattern,
    deco,
    disableToggle = false,
}: ProgramAccordionProps) {
    // disableToggle이 true면 모든 아이템 열림
    const allOpenValues = list.map((_, i) => `program_${i}`);
    const defaultValues = disableToggle ? allOpenValues : defaultOpenItems.map(index => `program_${index}`);

    return (
        <Accordion
            type="multiple"
            className={twMerge("flex flex-col gap-[8px]", className)}
            {...(disableToggle ? { value: allOpenValues, onValueChange: () => {} } : { defaultValue: defaultValues })}
        >
            {list.map((item, i) => (
                <AccordionItem key={`program_${i}`} value={`program_${i}`}>
                    <AccordionTrigger
                        className={`relative overflow-hidden p-[4px] hover:no-underline [&>svg]:mr-[8px] [&>svg]:stroke-1 [&>svg]:text-white md:[&>svg]:mr-[20px] [&_svg]:size-[24px] md:[&_svg]:size-[60px]${!item.contents || disableToggle ? " cursor-default" : ""} ${!item.contents || disableToggle ? " [&>svg]:hidden" : ""} ${item.background} bg-cover`}
                    >
                        {(item.pattern || pattern) && (
                            <div
                                className="pointer-events-none absolute inset-0"
                                style={{
                                    backgroundImage: `url(${item.pattern || pattern})`,
                                    backgroundPosition: "left top",
                                    backgroundRepeat: "repeat",
                                    opacity: 0.1,
                                    ...item.patternStyle,
                                }}
                            />
                        )}
                        {deco && (item.pattern || pattern) && (
                            <div
                                className="pointer-events-none absolute inset-0 mix-blend-screen"
                                style={{
                                    backgroundImage: `url(${deco})`,
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "calc(100% + 1px) -127px",
                                    backgroundSize: "382px 258px",
                                }}
                            />
                        )}
                        <div
                            className={`absolute left-[4px] top-[4px] h-[calc(100%-8px)] w-[calc(100%-8px)] border-[3px] border-white`}
                        />
                        <div
                            className={twMerge(
                                "w-full flex items-center justify-between px-[8px] py-[15px] xl:px-[20px]",
                                triggerClassName,
                            )}
                        >
                            <img src={item.img} alt="프로그램" className="h-[16px] md:h-[auto]" />
                            <p className="text-left font-['GongGothicMedium'] text-[16px] text-white md:text-[24px]">
                                {item.title}
                            </p>
                        </div>
                    </AccordionTrigger>
                    {item.contents && (
                        <AccordionContent
                            className={twMerge(
                                "p-[8px] text-[13px] bg-white font-['GongGothicLight'] leading-[1.5] md:text-[16px] md:p-[18px]",
                                contentClassName,
                            )}
                        >
                            {item.contents}
                        </AccordionContent>
                    )}
                </AccordionItem>
            ))}
        </Accordion>
    );
}
